import * as React from 'react';
import '../css/hero-banner.sass';

interface HeroBannerProps {
  bgImg: string;
  name: string;
  tagLine: React.ReactNode;
  children?: React.ReactNode;
}

export default function HeroBanner(props: HeroBannerProps) {
  return (
    <div className="hero-banner-section">
      <img className="hero-bg" alt={props.name} src={props.bgImg} />
      <div className="banner">
        <div className="banner-info">
          <h1>{props.name}</h1>
          <p>{props.tagLine}</p>
        </div>
        <div className="banner-content">{props.children}</div>
      </div>
    </div>
  );
}
